"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighV = exports.V0 = exports.ContractFactory = exports.Contract = exports.ContractVersion = void 0;
var buffer_1 = require("buffer");
var ContractId_1 = require("./ContractId");
var Serialization_1 = require("../../Handlers/Serialization");
var Hash_1 = require("./Hash");
var ContractVersion;
(function (ContractVersion) {
    ContractVersion[ContractVersion["V0"] = 0] = "V0";
})(ContractVersion = exports.ContractVersion || (exports.ContractVersion = {}));
var Contract = /** @class */ (function () {
    function Contract(version) {
        this.version = version;
    }
    Contract.prototype.toJson = function () {
        return {
            version: this.version,
            data: this.getDataAsString()
        };
    };
    return Contract;
}());
exports.Contract = Contract;
var ContractFactory = /** @class */ (function (_super) {
    __extends(ContractFactory, _super);
    function ContractFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContractFactory.read = function (buffer, offset) {
        var _a = Serialization_1.readVarInt(buffer, offset), version = _a.value, offset2 = _a.offset;
        switch (version) {
            case ContractVersion.V0:
                return V0.read(buffer, offset2);
            default:
                return HighV.read(buffer, offset2);
        }
    };
    ContractFactory.fromString = function (contractIdString) {
        var contractId = ContractId_1.ContractId.fromString(contractIdString);
        var contract;
        switch (contractId.version) {
            case ContractVersion.V0:
                var Version0 = V0.read(contractId.cHash.bytes, 0).contract;
                contract = Version0;
                break;
            default:
                var HighVersion = HighV.read(contractId.cHash.bytes, 0).contract;
                contract = HighVersion;
        }
        return contract;
    };
    ContractFactory.prototype.getDataAsString = function () {
        return "";
    };
    ContractFactory.prototype.getSize = function () {
        return 0;
    };
    ContractFactory.prototype.write = function (buffer, offset) {
        return 0;
    };
    return ContractFactory;
}(Contract));
exports.ContractFactory = ContractFactory;
var V0 = /** @class */ (function (_super) {
    __extends(V0, _super);
    function V0(contract) {
        var _this = _super.call(this, ContractVersion.V0) || this;
        _this.contract = contract;
        var code = contract.code, hints = contract.hints, rlimit = contract.rlimit, queries = contract.queries;
        _this.code = code;
        _this.hints = hints;
        _this.rlimit = rlimit;
        _this.queries = queries;
        return _this;
    }
    V0.read = function (buffer, offset) {
        var offset_size = Serialization_1.readVarInt(buffer, offset).offset;
        var _a = Serialization_1.readString(buffer, offset_size), code = _a.value, offset_code = _a.offset;
        var _b = Serialization_1.readString(buffer, offset_code), hints = _b.value, offset_hints = _b.offset;
        var _c = Serialization_1.readVarInt(buffer, offset_hints), rlimit = _c.value, offset_rlimit = _c.offset;
        var _d = Serialization_1.readVarInt(buffer, offset_rlimit), queries = _d.value, offset_queries = _d.offset;
        return { contract: new V0({ code: code, hints: hints, rlimit: rlimit, queries: queries }), offset: offset_queries };
    };
    V0.getCodeHash = function (code) {
        var buffer = buffer_1.Buffer.alloc(Serialization_1.getSizeOfStringNoLength(code));
        Serialization_1.writeStringNoLength(code, buffer, 0);
        return buffer.toString('hex');
    };
    V0.getVersionHash = function () {
        var buffer = buffer_1.Buffer.alloc(4);
        var offset = 0;
        buffer.writeUInt32BE(ContractVersion.V0, offset);
        return buffer.toString('hex');
    };
    V0.prototype.toJson = function () {
        return {
            contractId: ContractId_1.ContractId.makeContractId(this).toHex(),
            code: this.code
        };
    };
    V0.prototype.getDataAsString = function () {
        return "";
    };
    V0.prototype.getVersion = function () {
        return ContractVersion.V0;
    };
    V0.prototype.getSize = function () {
        return Serialization_1.getSizeOfVarInt(this.version) + Serialization_1.getSizeOfVarInt(this.payload()) + this.payload();
    };
    V0.prototype.write = function (buffer, offset) {
        offset = Serialization_1.writeVarInt(ContractVersion.V0, buffer, offset);
        offset = Serialization_1.writeVarInt(this.payload(), buffer, offset);
        offset = Serialization_1.writeString(this.code, buffer, offset);
        offset = Serialization_1.writeString(this.hints, buffer, offset);
        offset = Serialization_1.writeVarInt(this.rlimit, buffer, offset);
        offset = Serialization_1.writeVarInt(this.queries, buffer, offset);
        return offset;
    };
    V0.prototype.payload = function () {
        return Serialization_1.getSizeOfString(this.code) + Serialization_1.getSizeOfString(this.hints) + Serialization_1.getSizeOfVarInt(this.queries) + Serialization_1.getSizeOfVarInt(this.rlimit);
    };
    return V0;
}(Contract));
exports.V0 = V0;
var HighV = /** @class */ (function (_super) {
    __extends(HighV, _super);
    function HighV(contractId) {
        var _this = _super.call(this, contractId.version) || this;
        _this.contractId = contractId;
        _this.version = contractId.getVersion();
        _this.data = contractId.getHash().bytes;
        return _this;
    }
    HighV.read = function (buffer, offset) {
        var _a = Serialization_1.readVarInt(buffer, offset), version = _a.value, offset2 = _a.offset;
        var _b = Serialization_1.readVarInt(buffer, offset2), size = _b.value, offset3 = _b.offset;
        var data = buffer_1.Buffer.alloc(size);
        var offset4 = offset3 + buffer.copy(data, 0, offset2);
        var hash = new Hash_1.Hash(data.toString('hex'));
        return { contract: new HighV(new ContractId_1.ContractId(version, hash)), offset: offset4 };
    };
    HighV.prototype.getHash = function () {
        return new Hash_1.Hash(this.contractId.getHash().hash);
    };
    HighV.prototype.getSize = function () {
        return Serialization_1.getSizeOfVarInt(this.version) + Serialization_1.getSizeOfVarInt(this.data.length) + this.data.length;
    };
    HighV.prototype.write = function (buffer, offset) {
        offset = Serialization_1.writeVarInt(this.version, buffer, offset);
        offset = Serialization_1.writeVarInt(this.data.length, buffer, offset);
        return offset + this.data.copy(buffer, offset);
    };
    HighV.prototype.getDataAsString = function () {
        return this.data.toString('hex');
    };
    return HighV;
}(Contract));
exports.HighV = HighV;
//# sourceMappingURL=Contract.js.map